export const MIGRATION_ENABLE_CCP_PARTNER_IDS = [
  1029256, 2334436703, 211990, 2483897, 2197301, 1882599, 1652472, 2134551, 386976, 1864222,
  2535498, 407500, 3084994, 1755054, 648037, 1789861, 119985, 2052976, 2651387, 3322709, 238588,
  684017, 6997737, 3258943, 893169, 3306765, 3258906, 10124952, 3306426, 10757548, 3844211,
  11877047, 2009881, 13537118, 767237009, 273073018, 70073902, 14441818, 13978393, 13978532,
  13978612, 15895693, 16773707, 20548056, 24306399, 17756412, 2280391927, 123615860, 288622452,
  340313230, 2325779385, 342255344, 2325795875, 2327765579, 855869152, 994432905, 468620378,
  1045154104, 1063787258, 1302828777, 2388800336, 2431653465, 2441975253, 2460012356, 2469360207,
  2545129384, 2582079546, 2562304656, 2629622385, 2590007233, 3204879885, 5367285688, 2615963246,
  2620385979, 2639594106, 3715619384, 3715754778, 2665470047, 2666068695, 2666074762, 2666075893,
  2670874749, 2671521020, 2671520089, 2681798632, 2704684219, 2708604494, 3098961019, 2714037670,
  2726472522, 2726473942, 2726473988, 2726472275, 3267832191, 2895771186, 2782882672, 2839753873,
  2861394748, 2935608914, 2881354049, 2951073441, 2958335073, 2961998257, 3150043081, 3150357042,
  2969145203, 2998670974, 3006929714, 3025586880, 3074317316, 3152391342, 3152391142, 3185238459,
  3256401436, 9914637008, 3546644203, 3688785308, 3672131270, 3684766834, 4217647008, 4045219706,
  3876277850, 3781063175, 3959310980, 4224679155, 3937325983, 4006357698, 4642806193, 4314411132,
  4168784883, 5372393059, 3839842927, 3846336638, 5876988923, 5837837321, 4715816203, 5668869198,
  4895553101, 5067926972, 5263153917, 5598155485, 9689750869, 9652287659, 6744244653, 9690137198,
  6831525101, 6929652752, 7388942977, 6950653158, 8083014151, 7480607484, 7721429543, 7642572697,
  7851399915, 8041628140, 8296623627, 8313435723, 8546138935, 9141155594, 105526, 112758, 1028473,
  1459680, 2185152, 2197158, 2197240, 2389541, 2675996, 2707701, 2778927, 2788933, 3306756, 3583100,
  5868373, 12873883, 12891146, 33540523, 61802334, 278093915, 295737465, 330182632, 875000737,
  950120388, 1132379623, 1139500391, 2194755030, 2280391923, 2292235543, 2339470454, 2354403689,
  2358178085, 2373313719, 2436241390, 2450071841, 2451443211, 2477413087, 2483242952, 2528943727,
  2582079563, 2670879902, 2687217363, 2707916047, 2714447895, 2727166449, 2727168461, 2730267359,
  2736416447, 2750487041, 2798250634, 2899925623, 2961920069, 2991348672, 3024968818, 3025618926,
  3030025786, 3032473726, 3051631856, 3225300347, 3335851701, 3503299616, 3649173464, 3652051548,
  3741075232, 3755424159, 3785067798, 3840361778, 3963430260, 3977632825, 4171161897, 4188490889,
  4312723498, 4312857580, 4322561617, 4522852803, 4654740308, 4886245942, 5069078784, 5389849046,
  5437311987, 5518201193, 5810802757, 6285553608, 7268954460, 7381181097, 7902364789, 8157966967,
];

export const ENABLE_PRODUCT_OFFERING_KEYMAPPINGS_PARTNER_IDS = [
  3306765, 14441818, 15895693, 24306399, 855869152, 994432905, 2681798632, 2861394748, 10757548,
  468620378, 9652287659, 1864222, 2590007233, 3025586880,
];

export const ENABLE_CSV_FILTERING_PARTNER_IDS_PROD = [10757548, 3306426];
export const ENABLE_CSV_FILTERING_PARTNER_IDS_STG = [2493911172, 2493013114];

export const defaultFormState = {
  firstName: '',
  lastName: '',
  companyName: '',
  address1: '',
  address2: '',
  city: '',
  country: { label: '', value: '' },
  state: { label: '', value: '' },
  postcode: '',
  taxId: '',
  vatResponsible: null,
  vatStatus: null,
  taxExemptions: '',
};
